export default __webpack_public_path__ + "static/media/postgres.eba8cd3a.png";